import { Component, ViewChild } from "@angular/core";
import { ActivatedRoute, NavigationEnd, ParamMap, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { NeedaConfig } from "src/app/inventory/supplier/needa-config";
import { Invoice } from "src/app/purchase/invoice/invoice";
import { SupplierSearchCriteriaComponent } from "src/app/purchase/order/search/criteria/supplier-search-criteria.component";
import { Page } from "src/app/util/page";
import { Criteria } from "src/app/util/search/criteria/criteria";
import { FrCriteria } from "src/app/util/search/criteria/fr-criteria";
import { SearchComponent } from "src/app/util/search/search-component";
import { SearchRequest } from "src/app/util/search/search-request";
import { Supplier } from "../../supplier/supplier";
import { Reception } from "../reception";
import { ReceptionSearchResult } from "../reception-search-result";
import { ReceptionService } from "../reception-service";
import { NewReceptionComponent } from "./new-reception/new-reception.component";

@Component({
  templateUrl: './reception-search.component.html'
})
export class ReceptionSearchComponent extends SearchComponent<ReceptionSearchResult> {
  public loading = false;
  public error = false;

  public query = "";
  public needaConfig!: NeedaConfig;
  public reception!: Reception;
  public purchaseOrders!: string[];

  @ViewChild(SupplierSearchCriteriaComponent)
  supplierCriteria!: SupplierSearchCriteriaComponent;

  constructor(
    private modalService: NgbModal,
    private receptionService: ReceptionService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    super(new Map<string, Criteria>([
      ["supplier", new FrCriteria("Le fournisseur")]
    ]));
  }

  public addSupplierFilter(publisher: string) {
    this.addFilter("supplier", publisher);
  }

  public clearSupplier() {
    this.clearFilter("supplier");
  }

  public displaySupplierFilter(): string {
    return this.displayFilter("supplier");
  }

  ngOnInit(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        this.router.navigated = false;
      }
    });
  }

  ngAfterViewInit(): void {
    this.supplierCriteria.onFilterAdded().pipe(tap(supplier => this.addSupplierFilter(supplier))).subscribe();

    this.route.queryParamMap.subscribe(queryParam => setTimeout(() => this.searchWithQueryParam(queryParam)));
  }

  public onSearch(searchRequest: SearchRequest, page: number): Observable<Page<ReceptionSearchResult>> {
    var searchInvoiceRequest = {
      query: searchRequest.query,
      supplier: searchRequest.getValues("supplier"),
    };

    return this.receptionService.search(searchInvoiceRequest, page, 20);
  }

  public openReception(reception: ReceptionSearchResult) {
    this.router.navigateByUrl("/inventory/reception/" + reception.id);
  }

  public openNewReceptionModal() {
    this.modalService.open(NewReceptionComponent);
  }

  public refresh() {
    this.router.navigate(["/inventory/reception"], { queryParams: this.getQueryParams() });
  }

  public receive() {

  }

  public searchWithQueryParam(paramMap: ParamMap) {
    this.initWithParamMap(paramMap);

    this.search();
  }
}